import { FC, PropsWithChildren } from 'react';
import { ViewName } from "../../../../../components/Cards/templateCard/types";
import { motion, AnimatePresence } from 'framer-motion';


const Generic: FC<PropsWithChildren<{ viewName: ViewName }>> = ({ children, viewName }) => {
  const viewStyles = {
    Grid: "grid-cols-1 md:grid-cols-3 xl:grid-cols-4 gap-4",
    List: "grid-cols-1 gap-2 min-w-[750px] md:min-w-[1000px] w-full",
    Tower: "",
  };

  // Si children es un array, animar cada uno
  const childArray = Array.isArray(children) ? children : [children];

  return (
    <div className={`${viewStyles[viewName]} w-full grid`}>
      <AnimatePresence>
        {childArray.map((child, i) => (
          <motion.div
            key={child?.key ?? i}
            layout
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -40 }}
            transition={{ duration: 0.4, type: 'spring' }}
          >
            {child}
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
};

export default Generic;